import {createAsyncThunk, createSlice} from '@reduxjs/toolkit';
import {
  createDirectConversationIdAPIHelper,
  createGroupConversationIdAPIHelper,
  getConversationsListAPIHelper,
  getDirectMessagesAPIHelper,
  getGroupMessagesAPIHelper,
  sendDirectMessageAPIHelper,
  sendGroupMessageAPIHelper,
} from '../helpers/cceAPI';



const initialState = {
  conversations: [],
  messages: [],
  unreadCounts: [],
  onlineUsers: [],
  currentConversation: null,
};

export const getConversationsList = createAsyncThunk(
  '/conversations-list',
  async (params, thunkAPI) => {
    try {
      const response = await getConversationsListAPIHelper(params);
      return response;
    } catch (error) {
      return thunkAPI.rejectWithValue(error.message);
    }
  },
);

export const createDirectConversationId = createAsyncThunk(
  '/socketio/direct-chat/conversations',
  async (payload, thunkAPI) => {
    try {
      const response = await createDirectConversationIdAPIHelper(payload);
      return response;
    } catch (error) {
      return thunkAPI.rejectWithValue(error.message);
    }
  },
);

export const createGroupConversationId = createAsyncThunk(
  '/socketio/group-chat/conversations',
  async (payload, thunkAPI) => {
    try {
      const response = await createGroupConversationIdAPIHelper(payload);
      return response;
    } catch (error) {
      return thunkAPI.rejectWithValue(error.message);
    }
  },
);

export const sendDirectMessage = createAsyncThunk(
  '/chat/send-direct-message',
  async (payload, thunkAPI) => {
    try {
      const response = await sendDirectMessageAPIHelper(payload);
      return response;
    } catch (error) {
      return thunkAPI.rejectWithValue(error.message);
    }
  },
);

export const sendGroupMessage = createAsyncThunk(
  '/chat/send-group-message',
  async (payload, thunkAPI) => {
    try {
      const response = await sendGroupMessageAPIHelper(payload);
      return response;
    } catch (error) {
      return thunkAPI.rejectWithValue(error.message);
    }
  },
);

export const getDirectMessages = createAsyncThunk(
  '/chat/direct-messages',
  async (params, thunkAPI) => {
    try {
      const response = await getDirectMessagesAPIHelper(params);
      return response;
    } catch (error) {
      return thunkAPI.rejectWithValue(error.message);
    }
  },
);

export const getGroupMessages = createAsyncThunk(
  '/chat/group-messages',
  async (params, thunkAPI) => {
    try {
      const response = await getGroupMessagesAPIHelper(params);
      return response;
    } catch (error) {
      return thunkAPI.rejectWithValue(error.message);
    }
  },
);

const cceSlice = createSlice({
  name: 'cce',
  initialState,
  reducers: {
    setCurrentConversation: (state, action) => {
      state.currentConversation = action?.payload;
    },
    setUnreadCount: (state, action) => {
      state.unreadCounts = action?.payload;
    },
    setOnlineUsers: (state, action) => {
      state.onlineUsers = action?.payload;
    },
    setConversations: (state, action) => {
      state.conversations = action?.payload;
    },
  },
  extraReducers: builder => {
    builder
      .addCase(getConversationsList.pending, (state, action) => {
        console.log('getConversationsList pending', action);
      })
      .addCase(getConversationsList.fulfilled, (state, action) => {
        state.conversations = action?.payload?.conversations || [];
        console.log('getConversationsList fulfilled', action);
      })
      .addCase(getConversationsList.rejected, (state, action) => {
        console.log('getConversationsList rejected', action);
      })
      .addCase(createDirectConversationId.pending, (state, action) => {
        console.log('createDirectConversationId pending', action);
      })
      .addCase(createDirectConversationId.fulfilled, (state, action) => {
        console.log('createDirectConversationId fulfilled', action);
      })
      .addCase(createDirectConversationId.rejected, (state, action) => {
        console.log('createDirectConversationId rejected', action);
      })
      .addCase(createGroupConversationId.pending, (state, action) => {
        console.log('createGroupConversationId pending', action);
      })
      .addCase(createGroupConversationId.fulfilled, (state, action) => {
        console.log('createGroupConversationId fulfilled', action);
      })
      .addCase(createGroupConversationId.rejected, (state, action) => {
        console.log('createGroupConversationId rejected', action);
      })
      .addCase(sendDirectMessage.fulfilled, (state, action) => {
        console.log('sendDirectMessage fulfilled', action);
      })
      .addCase(sendDirectMessage.rejected, (state, action) => {
        console.log('sendDirectMessage rejected', action);
      })
      .addCase(sendGroupMessage.fulfilled, (state, action) => {
        console.log('sendGroupMessage fulfilled', action);
      })
      .addCase(sendGroupMessage.rejected, (state, action) => {
        console.log('sendGroupMessage rejected', action);
      })
      .addCase(getDirectMessages.fulfilled, (state, action) => {
        state.messages = action?.payload?.data;
        console.log('getDirectMessages fulfilled', action);
      })
      .addCase(getDirectMessages.rejected, (state, action) => {
        console.log('getDirectMessages rejected', action);
      })
      .addCase(getGroupMessages.fulfilled, (state, action) => {
        state.messages = action?.payload?.data;
        console.log('getGroupMessages fulfilled', action);
      })
      .addCase(getGroupMessages.rejected, (state, action) => {
        console.log('getGroupMessages rejected', action);
      });
  },
});

export const {
  setCurrentConversation,
  setUnreadCount,
  setOnlineUsers,
  setConversations,
} = cceSlice.actions;
export default cceSlice.reducer;
